var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 18C37.8937 18 30.825 24.5906 30.0656 33L30.0563 33.0094H23.9906C22.3312 33.0094 20.9906 34.35 20.9906 36.0094V44.2594C20.9906 46.3313 19.3125 48.0094 17.2406 48.0094H12C11.8594 48.0094 11.7188 48 11.5781 47.9906C11.4656 48 11.3531 48.0094 11.2406 48.0094H9.74063C7.66875 48.0094 5.99063 46.3313 5.99063 44.2594V33.7594C5.99063 33.6656 5.99062 33.5812 6 33.4969V26.9625H3C1.3125 26.9625 0 25.6406 0 23.9531C0 23.1094 0.28125 22.3594 0.9375 21.7031L24.9844 0.75C25.6406 0.09375 26.3906 0 27.0469 0C27.7031 0 28.4531 0.1875 29.0156 0.65625L48.9469 18.1781C48.15 18.0656 47.3344 18 46.5 18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 22C39.824 22 34 27.824 34 35C34 42.176 39.824 48 47 48C54.176 48 60 42.176 60 35C60 27.824 54.176 22 47 22ZM54.8 36.3H48.3V42.8H45.7V36.3H39.2V33.7H45.7V27.2H48.3V33.7H54.8V36.3Z",
    fill: "#448870"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHome);
export default __webpack_public_path__ + "static/media/add-home.cdfbc6a8f3ad08f71748b015201b4bd3.svg";
export { ForwardRef as ReactComponent };